import GIF from 'gif.js.optimized'
import { FPS } from '../constants'
import { CreationToolFrame } from '../types/index'

const CHILL_ZONE = {}

const getGifFromFrames = async (frames: CreationToolFrame[], cacheId?: string): Promise<File> =>
    new Promise((resolve, reject) => {
        if (cacheId && CHILL_ZONE[cacheId]) {
            return resolve(CHILL_ZONE[cacheId])
        }

        const { canvas } = frames[0]

        const gif = new GIF({
            workers: 4,
            workerScript: '/static/dist/workers/gif.worker.js',
            quality: 6,
            dither: 'FloydSteinberg',
            transparent: 0x00ff00,
            height: canvas.height,
            width: canvas.width,
        })

        frames.forEach(({ canvas, frameCount = 1 }) => {
            const frame = document.createElement('canvas')
            const frameContext = frame.getContext('2d')
            frame.width = canvas.width
            frame.height = canvas.height
            if (frameContext) {
                frameContext.fillStyle = '#00FF00'
                frameContext.fillRect(0, 0, frame.width, frame.height)
                frameContext.drawImage(canvas, 0, 0)
            }
            gif.addFrame(frame, { delay: frameCount * FPS })
        })

        gif.on('finished', blob => {
            blob.lastModifiedDate = new Date()
            blob.name = 'giphy.gif'
            blob.accepted = true
            if (cacheId) {
                CHILL_ZONE[cacheId] = blob
            }
            resolve(blob)
        })

        gif.on('error', () => reject())
        gif.render()
    })

export default getGifFromFrames
